import React from "react"

const Spinner = props => {

    const color = props.colorClass || "text-warning"

    return (
        <div className="text-center">
            <div className={"spinner-border " + color} role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export default Spinner